function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.006,83.805H3c-1.656,0-3,1.344-3,3c0,1.657,1.344,3,3,3h87.006c1.656,0,3-1.343,3-3 C93.006,85.148,91.662,83.805,90.006,83.805"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.913,76.748c0.09,0,0.181-0.004,0.271-0.013l14.784-1.343c0.699-0.063,1.354-0.371,1.851-0.867 l56.395-56.395c0.563-0.563,0.879-1.326,0.879-2.121c0-0.796-0.315-1.559-0.879-2.121L71.17,0.845c-1.125-1.126-3.117-1.126-4.242,0 L10.532,57.24c-0.475,0.475-0.776,1.094-0.856,1.761L7.935,73.387c-0.108,0.9,0.195,1.801,0.825,2.45 C9.328,76.422,10.106,76.748,10.913,76.748 M15.508,60.75L69.049,7.208l8.801,8.802L24.344,69.515l-10.007,0.909L15.508,60.75z"
});

var SvgModifica = function SvgModifica(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 94,
    height: 91,
    viewBox: "-0.403 -0.823 94 91",
    enableBackground: "new -0.403 -0.823 94 91",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgModifica, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/modifica.58165c05.svg";
export { ForwardRef as ReactComponent };